<template>
    <Button @click="click()" :disabled="!parecer" :label="buttonLabel" severity="primary" :icon="buttonIcon" text />

</template>

<script setup>
import {ref} from 'vue';
import Button from 'primevue/button';
import { copiarString } from '@/utils/copiarString';
const props = defineProps({
    parecer: {
        type: String,
        default: ''
    }
})

const buttonLabel = ref('Copiar');
const buttonIcon = ref("pi pi-copy");

function click(){
    copiarString(props.parecer);
    buttonLabel.value = "Copiado";
    buttonIcon.value = "pi pi-check";
}

</script>